import axios from "axios";
import jwtDecode from "jwt-decode";
import {toast} from "react-toastify";
import {getAccessToken} from "../../../api/getAccessToken.js";

export async function upsertNote(note_text, subscription_ids, note_id) {
    return await axios.post(`${process.env.REACT_APP_RIS_API_URL}/data-subscriptions/data-subscriptions/upsert-notes`, {
            subscription_ids, note_text, note_id
        }, {
            headers:
                {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getAccessToken()}`
                }
        }
    )
}

export async function updateSubscriptionDisableMailer(subscription_ids, disable_mailer) {
    return await axios.post(`${process.env.REACT_APP_RIS_API_URL}/data-subscriptions/data-subscriptions/update-batch-disabled-mailer`, {
            subscription_ids, disable_mailer
        }, {
            headers:
                {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getAccessToken()}`
                }
        }
    )
}

export async function handleForceSendClick(auth0AccessToken) {
    const email = jwtDecode(auth0AccessToken)["https://aot/email"]
    return axios.post(`${process.env.REACT_APP_RIS_API_URL}/mid-market-report/dags/trigger?dag_id=ignite_plus.subscription_mailer`, {
        conf: {
            "triggered_by": email,
            "email_recipients_override": [email],
        }
    }, {
        headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${auth0AccessToken}`
        },
    }).then((response) => {
        if (response.status === 200) {
            toast.success(`Successfully triggered ignite_plus.subscription_mailer`)
        } else {
            toast.error(`Unsuccessful Operation: ${response.status} ${response.statusText}`)
        }
    }).catch((e) => {
        toast.error(e)
    })
}

export const updateSubscriptionStatus = async (subscription_ids, status, status_updated_by) => {
    await axios.put(`${process.env.REACT_APP_RIS_API_URL}/data-subscriptions/data-subscriptions/update-subscription-status`, {
            subscription_ids,
            status,
            status_updated_by
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getAccessToken()}`
            },
        }
    )
}
